import InputForm from "./InputForm";

export default InputForm;
